"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoutLink = void 0;
var _react = _interopRequireDefault(require("react"));
var _MenuContext = require("./MenuContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const LogoutLink = _ref => {
  let {
    text,
    ...props
  } = _ref;
  const menuContext = (0, _MenuContext.useMenuContext)();
  const onClick = e => {
    e.preventDefault();
    menuContext.onLogout && menuContext.onLogout();
  };
  return /*#__PURE__*/_react.default.createElement("a", _extends({
    href: "/",
    onClick: onClick,
    "data-cy": "HeaderLogoutLink"
  }, props), /*#__PURE__*/_react.default.createElement("span", null, text));
};
exports.LogoutLink = LogoutLink;